// 칭찬하고 할인받기 API 래퍼(개선 9~12).

import type { ComplimentStateDto, OrderType } from "@oo/shared";
import { api } from "@/api/client.ts";

// 현재 칭찬 상태(잠김 여부 + 무작위 후보 또는 고정 선택). 주문 유형별 후보 개수가 달라 type 을 넘긴다.
export async function getComplimentState(type: OrderType): Promise<ComplimentStateDto> {
  const data = await api.get<{ state: ComplimentStateDto }>(
    `/me/compliment?type=${encodeURIComponent(type)}`,
  );
  return data.state;
}

// 칭찬 1개 선택 -> 서버가 가중 랜덤 할인액을 정해 잠근다. 반환: 고른 칭찬 + 할인액.
export async function selectCompliment(
  complimentText: string,
): Promise<{ complimentText: string; discountKrw: number }> {
  return api.post<{ complimentText: string; discountKrw: number }>("/me/compliment/select", {
    complimentText,
  });
}
